



































import {Component, Vue, Prop} from 'vue-property-decorator';
import {DataTableHeader} from 'vuetify';
import {IDataEvent} from '@/models/IDataEvent';

@Component({})
export default class EventsFollowFacebookPixelTable extends Vue {
  @Prop() data!: IDataEvent[];
  @Prop() loading!: boolean;

  protected headers: DataTableHeader[] = [
    {text: 'Facebook Pixel ID', align: 'start', sortable: false, value: 'facebook_pixel_id', width: 80},
    {text: 'View Content', align: 'start', sortable: false, value: 'view_content', width: 80},
    {text: 'Add To Cart', align: 'start', sortable: false, value: 'add_to_cart', width: 80},
    {text: 'Initiate Checkout', align: 'start', sortable: false, value: 'initiate_checkout', width: 80},
    {text: 'Purchase', align: 'start', sortable: false, value: 'purchase', width: 80},
    {text: 'Page View', align: 'start', sortable: false, value: 'page_view', width: 80},
  ];

}
